// extracted by mini-css-extract-plugin
export default {"layout-wrap":"without-header-without-footer_layout-wrap__WX4S7"};